import { StyleSheet, View } from 'react-native';

import { Dropdown, IconInfo, Text, tokens } from '@fhs/ui';
import { PHONE_NUMBER_STATEMENT } from '@fhs-legacy/frontend/src/utils/test-ids';

export default function PhoneNumberRequiredCalloutToggle() {
  return (
    <View style={styles.phoneToggleContainer}>
      <View style={{ width: '100%' }}>
        <Dropdown>
          <Dropdown.Trigger>
            {() => (
              <View
                style={styles.phoneToggleContent}
                testID={PHONE_NUMBER_STATEMENT}
                accessibilityRole="text"
                accessibilityLabel="We need your phone number to contact you about your delivery and to ensure your
                order reaches you safely."
              >
                <IconInfo size={18} color={tokens.colors.$houseDark} />
                <Text.Ui size="sm" style={styles.phoneToggleText}>
                  Why do you need my phone number?
                </Text.Ui>
              </View>
            )}
          </Dropdown.Trigger>
          <Dropdown.Pane style={styles.dropdownPane}>
            <View style={styles.phoneInfoContent}>
              <Text.Ui size="md">
                We need your phone number to contact you about your delivery and to ensure your
                order reaches you safely.
              </Text.Ui>
            </View>
          </Dropdown.Pane>
        </Dropdown>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  phoneToggleContainer: {
    position: 'relative',
    zIndex: 10,
    width: '100%',
    paddingHorizontal: 8,
    paddingBottom: 13,
  },
  phoneToggleContent: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    gap: 8,
  },
  phoneToggleText: {
    flex: 1,
    marginLeft: -3,
  },
  dropdownPane: {
    left: 16,
    right: 16,
    // override default because it cuts off right side
    transform: 'none',
    maxWidth: 330,
  },
  phoneInfoContent: {
    padding: 12,
    borderRadius: 8,
    maxWidth: '100%',
    shadowColor: tokens.colors.$black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
});
